export default __webpack_public_path__ + "static/media/woocommerce-platform-poster.94fe90f0.png";